import React from "react";
import "./MenuHamburguesa.css";

function MenuHamburguesa({ isMenuOpen, toggleMenu }) {
  return (
    <div className="menuHamburguesa" onClick={toggleMenu}>
      <span className={isMenuOpen ? "barOpen" : "bar"}></span>
      <span className={isMenuOpen ? "barOpen" : "bar"}></span>
      <span className={isMenuOpen ? "barOpen" : "bar"}></span>
    </div>
  );
}

export default MenuHamburguesa;
